export const init = () => {
    if (document.querySelector('.b-wiki-navigator')) {
        const sidebar = document.querySelector('.b-wiki-navigator');
        const accordions = document.querySelectorAll('.b-wiki-navigator__category');
        accordions.forEach((item) => {
            const button = item.querySelector('.b-wiki-navigator__action');
            button.addEventListener('click', (e) => {
                e.preventDefault();
                item.classList.toggle('active');
            })
        });
        setSidebarHeight(sidebar);
        window.addEventListener('scroll', () => {
            setSidebarHeight(sidebar);
        });
    }
    if (document.querySelector('.b-manuals-navigator')) {
        const sidebar = document.querySelector('.b-manuals-navigator');
        const accordions = document.querySelectorAll('.b-manuals-navigator__category');
        accordions.forEach((item) => {
            if (item.querySelector('.b-manuals-navigator__action .icon-svg')) {
                const button = item.querySelector('.b-manuals-navigator__action .icon-svg');
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    item.classList.toggle('active');
                })
            }
        });
        setSidebarHeight(sidebar);
        window.addEventListener('scroll', () => {
            setSidebarHeight(sidebar);
        });
    }
    function setSidebarHeight(sidebar) {
        const sidebarPosition = sidebar.getBoundingClientRect().top;
        sidebar.style.maxHeight = `calc(100vh - ${sidebarPosition}px)`;
    }
}